export enum LocumsContractRequestsEvents {
    LOCUMS_CONTRACT_REQUESTS_LOAD = 'locums-contract-requests:load-contract-requests-for-locums-1099',
    LOCUMS_CONTRACT_REQUEST_PAGE_OPENED = 'locums-contract-request:contract-request-page-opened-for-locums-1099',
    LOCUMS_CONTRACT_REQUEST_DIALOG_OPEN = 'locums-contract-request:open-contract-request-dialog-for-locums-1099'
}
